import React, { memo } from 'react';

import { Map } from 'common/utils/Map/types/map';
import { Grid, Chip, Typography } from 'e100-react-components';
import { MapInfoWindow } from 'entities/map';
import { ChargePriceType, useBestRouteStations } from 'entities/stations';

import { useStyles } from './styles';
import { useGetStationByCode } from 'store/features/stations/selectors/stations';
import useMarkerClick from 'pages/Map/hooks/useMarkerClick';
import { useIntl } from 'react-intl';
import { useStationInfoContext } from 'common/context/stationInfo';

import { EMPTY_ARRAY } from 'common/constants';
import { BestPriceIcon } from 'shared/components';

export const BestRouteCountryStation = memo(({ map }: BestRouteCountryStationProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const bestRouteStations = useBestRouteStations() || EMPTY_ARRAY;
  const getStationByCode = useGetStationByCode();
  const onMarkerClick = useMarkerClick();
  const { setStationModalData } = useStationInfoContext();

  if (!bestRouteStations.length) {
    return null;
  }

  return (
    <>
      {bestRouteStations?.map(({ stationCode, coordinates, services, countryCode }) => (
        <MapInfoWindow
          coordinates={[coordinates.latitude, coordinates.longitude]}
          map={map}
          
        >
          <div
            className={classes.container}
            onClick={() => {
              const station = getStationByCode(stationCode);
              if (station) {
                onMarkerClick(station);
                setStationModalData({ ...station });
              }
            }}
          >
            {services.map(({ name, price, priceType, excise }) => (
              <div className={classes.priceContainer}>
                {price && (
                  <>
                    <Typography variant="caption">
                      {`${name}: `}
                      <b>{price}</b>
                    </Typography>
                    {ChargePriceType.NetExcise === Number(priceType) && !excise && (
                      <Typography variant="caption" color="secondary" gutterBottom>
                        {formatMessage({ id: 'notExistExcisePrice' })}
                      </Typography>
                    )}
                    <Grid container>
                      <Grid item xs={12} />
                    </Grid>
                  </>
                )}
              </div>
            ))}

            <Grid container direction="row" wrap="nowrap">
              <Chip
                label={stationCode}
                size="small"
                classes={{
                  root: classes.chip,
                  label: classes.chipLabel,
                }}
              />
              <BestPriceIcon label={formatMessage({ id: 'bestPriceInRoute' }, { countryCode })} />
            </Grid>
          </div>
        </MapInfoWindow>
      ))}
    </>
  );
});

interface BestRouteCountryStationProps {
  map: Map | null;
}
